import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { UserService } from '@core/services/user.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const userService = inject(UserService);


  // if (req.url.includes('login') || req.url.includes('Account')) {
  //   return next(req);
  // }

  const cloned = req.clone({
    withCredentials: true,
  });

  return next(cloned).pipe(
    catchError((error: HttpErrorResponse) => {
      const isOnLogin = router.url.startsWith('/auth/login');

      const status = error.status;
      const payload = error.error as any;

      const sessionExpired =
        status === 401 &&
        ['Session expired or invalid', 'No session cookie'].includes(payload?.message);

      if (sessionExpired && !isOnLogin) {
        userService.clearSession();
        router.navigate(['/auth/login'], { replaceUrl: true });
      }

      return throwError(() => error);
    })

  );
};
